"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationModal = void 0;
var Modal_1 = __importDefault(require("@material-ui/core/Modal"));
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var CsButton_1 = __importDefault(require("../Buttons/CsButton"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid/Grid"));
var ConfirmationModalStyle_1 = require("./ConfirmationModalStyle");
exports.ConfirmationModal = function (_a) {
    var handleConfirm = _a.handleConfirm, open = _a.open, handleClose = _a.handleClose, textMain = _a.textMain, textCancel = _a.textCancel, textHeading = _a.textHeading, textConfirm = _a.textConfirm;
    var classes = ConfirmationModalStyle_1.useStyles();
    return (react_1.default.createElement(Modal_1.default, { className: classes.modal, open: open, onClose: handleClose },
        react_1.default.createElement("div", { className: classes.paper },
            react_1.default.createElement(core_1.Typography, { variant: 'h4' }, textHeading),
            react_1.default.createElement(core_1.Typography, { variant: 'h6', style: { paddingTop: '20px' } }, textMain),
            react_1.default.createElement(Grid_1.default, { container: true, spacing: 2, style: { paddingTop: '30px', paddingBottom: '20px ' } },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 2 }),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 5 },
                    react_1.default.createElement(CsButton_1.default, { fullwidth: true, onClick: handleClose }, textCancel)),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 5 },
                    react_1.default.createElement(CsButton_1.default, { fullwidth: true, onClick: function () {
                            handleConfirm();
                            handleClose();
                        }, solid: true }, textConfirm))))));
};
exports.default = exports.ConfirmationModal;
//# sourceMappingURL=ConfirmationModal.js.map